import {RoomProtocolMapperClient} from '../../shared/scripts/RoomProtocolMapperClient.ts'
import {PlayerEnums} from '../../../shared/GameEnums.ts'
import {RoomClientState} from '../../shared/scripts/RoomClientState.ts'
import {AnalyticEventValue} from '../../../shared/entity_datas/EntityDatas.ts'
import {navigateToPage} from '../../shared/scripts/ui_utils/ClientUtils.ts'
import {ViewPopupBecomeMemberGameplay} from '../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay.ts'
import {UIManager} from './ui_html/UIManager.ts'
import {convertChatResponseToText, convertFailedToSendReasonToChatData} from '../../shared/scripts/RoomChatUtils.ts'
import {LobbyImage} from '@colonist/types'

export function registerWebRoomClientHandlers(roomClient: RoomProtocolMapperClient, uiManager: UIManager) {
    roomClient.onRoomStateUpdated((roomState: RoomClientState) => {
        uiManager.room.updateRoom(roomState)
    })

    roomClient.onInfoMessageUpdated((data: PlayerEnums.RoomInfoMessage) => {
        uiManager.room.center.infoMessageController.setMessage(data)
    })

    roomClient.onSeedOrderSelected((data) => {
        uiManager.room.updateSeedOrderSelection(data)
    })

    roomClient.onPlayOrderSelected((data) => {
        uiManager.room.updatePlayOrderSelection(data)
    })

    roomClient.onGotKicked((roomId, canRejoin) => {
        uiManager.lobby.onGotKicked(roomId, canRejoin)
        uiManager.room.leaveRoom(undefined, undefined, true)
    })

    roomClient.onKickedInactiveHost(() => {
        uiManager.room.onKickedInactiveHost()
    })

    roomClient.onFailedToStartGameMembershipRequired(() => {
        const analyticEventValue = AnalyticEventValue.RoomPremiumItemPopupBecomeAMemberButton
        const checkAction = () => {
            navigateToPage('/store#membership', true)
        }
        new ViewPopupBecomeMemberGameplay(checkAction, analyticEventValue)
    })

    roomClient.onReceivedChatMessage((message, senderUsername, senderIcon) => {
        uiManager.room.chat.postMessage(message, senderUsername, senderIcon)
    })

    roomClient.onFailedToSendChatMessage((reason, mutedUntil) => {
        uiManager.room.chat.post({
            text: convertFailedToSendReasonToChatData(reason, mutedUntil),
            icon: LobbyImage.Lightning,
        })
    })

    roomClient.onReceivedChatResponse((response) => {
        for(const responseText of convertChatResponseToText(response)) {
            uiManager.room.chat.post({
                text: responseText,
                icon: LobbyImage.Lightning,
            })
        }
    })
}
